<template>
<div class="hello">
    <div class="pop_content_wrap" style="min-width:400px;">
        <div class="top">
            <h3>Writing Evaluation({{info.writing_num}}회차)</h3>
            <h4 class="mt10"><span class="font16">Student</span> : {{info.kname}}</h4>
        </div>
        <div class="cb pop-ev-write-wrap">
            <div class="write-title pt-20"><span class="ico-r">1</span> Writing Skill Competency (<span class="col-red font16">{{ev.ev_point_sum}}</span>/100Points)</div>
            <div class="write-content">
                <div class="float-left graph-block">
                    <div class="pt10">
                        <div class="graph-bar-wrap">
                            <div class="graph-bar-head">
                                <div class="graph-bar-head-tit-fir"></div>
                                <div class="graph-bar-head-tit">Need to<br>Improve</div>
                                <div class="graph-bar-head-tit">Fair</div>
                                <div class="graph-bar-head-tit">Good</div>
                                <div class="graph-bar-head-tit">Very Good</div>
                                <div class="graph-bar-head-tit">Excellent</div>
                            </div>
                            <div class="graph-bar-body">
                                <div class="graph-bar-body-list">
                                    <div class="graph-bar-body-item col-s1">
                                        <div class="graph-bar-tit">Topic Development</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index">
                                            <div class="graph-per-bar" :class="perClass(ev.ev_point1,item)" ></div>
                                        </div>
                                    </div>
                                    <div class="graph-bar-body-item col-s2">
                                        <div class="graph-bar-tit">Organization</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index">
                                            <div class="graph-per-bar" :class="perClass(ev.ev_point2,item)" ></div>
                                        </div>
                                    </div>
                                    <div class="graph-bar-body-item col-s3">
                                        <div class="graph-bar-tit">Sentence Structure</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5"  :key="index">
                                            <div class="graph-per-bar" :class="perClass(ev.ev_point3,item)" ></div>
                                        </div>
                                    </div>
                                    <div class="graph-bar-body-item col-s4">
                                        <div class="graph-bar-tit">Grammar Usage</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5"  :key="index">
                                            <div class="graph-per-bar" :class="perClass(ev.ev_point4,item)" ></div>
                                        </div>
                                    </div>
                                    <div class="graph-bar-body-item col-s5">
                                        <div class="graph-bar-tit">Word Choice</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5"  :key="index">
                                            <div class="graph-per-bar" :class="perClass(ev.ev_point5,item)" ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="float-left chart-block" style="margin-top:10px">
                    <div id="chartdiv1" style="width:100%;height:240px;"></div>
                </div>

            </div>
            <br>
            <div class="write-title pt-20"><span class="ico-r">2</span> Overall Comments </div>
            <!-- <div class="write-desc mt10">(Each needs at least one sentence more than 50 words.)</div> -->
            <div class="write-content">
                <textarea readonly id="s_comment" class="textarea" v-model="ev.comment" style="width:100%; height:100px;"></textarea>
            </div>
        </div>
        <div class="btn mt10 pointer" style="padding:20px;">
            <button @click="closePOP()">닫기</button>
        </div>
    </div>

</div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
export default {
    name: 'pop_evview',
    components: {},
    props: {
        msg: String
    },
    data: () => ({
        is_loader:true, idx_itm_class_writing_user: "", use_writing_ev: '',
        ev: {},
        ev_txt : [
              { en:'Topic Development'    , kr:'Topic Development' }
            , { en:'Organization'         , kr:'Organization' }
            , { en:'Sentence\nStructure'  , kr:'Sentence\nStructure' }
            , { en:'Grammar\nUsage'       , kr:'Grammar\nUsage' }
            , { en:'Word\nChoice'         , kr:'Word\nChoice' }
        ],
        info:{},
        lang : 'en'
    }),
    created() {

    },
    mounted() {
        this.idx_itm_class_writing_user = this.$route.query.idx_wu;
        // console.log(this.idx_itm_class_writing_user);
        this.initPage();
    },
    methods: {
        closePOP: function(){
            window.close();
        },
        initPage:function(){
            if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else if(location.hostname == "st.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "student.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "m.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "http://itm.jordan.net");
            }
            var me = this;
            var params = {
                idx : this.idx_itm_class_writing_user,
                idx_member : localStorage.getItem("uidx")
            }
            this.axios.get(this.$store.state.host + "/rest/mobile/getClassUserInfo", {
                params: params
            }).then(function (res) {
            //   console.log(res);
                if(res.data.err == 0){
                    me.use_writing_ev = res.data.info.use_writing_ev;
                    console.log(me.use_writing_ev);
                    me.ev = res.data.ev_info;
                    me.info = res.data.info;
                    // console.log(me.ev);
                    me.mkChart();
                }
            });
        },
        mkChart(){
             var dat    = {
                    ev_txt : this.ev_txt
                , ev     : this.ev
                // , avg    : this.avg_report
            };
            

            var value_txt_lst = [
                "", "매우 노력 필요", "매우 노력 필요", "노력 필요", "노력 필요", "보통", "보통", "우수", "우수", "매우 뛰어남", "매우 뛰어남"
            ];
            if (this.lang == "EN") {
                dat.ev_txt.fluency_str = "Fluency";
                dat.ev_txt.accuracy_str = "Accuracy";
                dat.ev_txt.pronunciation_str = "Pronunciation";
                dat.ev_txt.comprehension_str = "Comprehension";
                dat.ev_txt.participation_str = "Participation";
                dat.ev_txt.preparation_str = "Preparation";

                value_txt_lst = [
                    "", "Need to Imporve", "Need to Imporve", "Fair", "Fair", "Good", "Good", "Very Good", "Very Good", "Excellent", "Excellent"
                ];

            } else if (this.lang == "CH") {
                dat.ev_txt.fluency_str = "流畅性";
                dat.ev_txt.accuracy_str = "准确度";
                dat.ev_txt.pronunciation_str = "发音";
                dat.ev_txt.comprehension_str = "理解度";
                dat.ev_txt.participation_str = "參與度";
                dat.ev_txt.preparation_str = "準備性";
            }
            console.log(value_txt_lst);
            let chart = am4core.create("chartdiv1", am4charts.RadarChart);
            /* Add data */
            chart.data = [{
                "field": dat.ev_txt[0][this.lang],
                "ptf":  dat.ev.ev_point1
            }, {
                "field": dat.ev_txt[1][this.lang],
                "ptf":  dat.ev.ev_point2,
            }, {
                "field": dat.ev_txt[2][this.lang],
                "ptf":  dat.ev.ev_point3,
            }, {
                "field": dat.ev_txt[3][this.lang],
                "ptf":  dat.ev.ev_point4,
            }, {
                "field": dat.ev_txt[4][this.lang],
                "ptf":  dat.ev.ev_point5,
            }];

            /* Create axes */
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "field";

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            console.log(valueAxis);
            // valueAxis.m
            valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
            valueAxis.renderer.axisFills.template.fillOpacity = 0.05;
            valueAxis.min = 0;
            valueAxis.max = 20;
            let series = chart.series.push(new am4charts.RadarSeries());
            series.dataFields.valueY = "ptf";
            series.dataFields.categoryX = "field";
            series.stroke = am4core.color("#53CAFF");
            series.background.fill = am4core.color("#53CAFF");
            series.name = "Sales";
            series.strokeWidth = 2;
        },
        perClass: function(value,i) {
            console.log(value);
            console.log(i);
            
            var className = "m-100";
            var currentNode = i*4;
            if (value >= currentNode) {
                return className;
            }
               
            if( ( currentNode - value ) >= 4 ) {
                return "";
            }

            switch(value % 4) {
                case 0:
                     className='m-100';
                     break;
                case 1:
                    className='m-25';
                    break;
                case 2:
                    className='m-50';
                    break;
                case 3:
                    className='m-75';
                    break;

            }

            return className;
           
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');
.pop_content_wrap{
    padding: 20px;
}
.top {
            background: #53CAFF;
            padding: 20px;
        }
        .top h3 {
            color: #ffffff;
            font-size: 24px;
            margin-bottom: 20px;
        }
        .top h4 {
            color: #ffffff;
        }
        .top h4 span {
            background: #ffffff;
            color: #53CAFF;
            padding: 2px 10px;
            border-radius: 50px;
        }
		.circle {
			position: relative;
			display: inline-block;
			width: 28px;
			height: 28px;
			cursor: pointer;
			border: 1px solid #4cc2a5;
			border-radius: 100%;
			vertical-align: middle;
			background-color: #ffffff;
			overflow: hidden;		
		}
		.circle_on {
			position: relative;
			display: inline-block;
			width: 28px;
			height: 28px;
			cursor: pointer;
			border: 1px solid #4cc2a5;
			border-radius: 100%;
			vertical-align: middle;
			background-color: #4cc2a5;
			overflow: hidden;		
		}
		.pfill {
			background-color: #0079c2;
		}
		.tbl-bar {
			border-collapse: 2px;
			margin: 2px;
		}
		.gr02 {
			border: 1px solid #ddd;
		}
		.gr01 {
			border: 1px solid #ddd;
        }
        
        .pop-ev-write-wrap .graph-block {
            width: 560px;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head {
            display: table;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head .graph-bar-head-tit-fir {
            width: 180px;
            height: 30px;
            display: table-cell;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head .graph-bar-head-tit {
            width: 75px;
            height: 30px;
            text-align: center;
            display: table-cell;
            vertical-align: bottom;
            font-size: 12px;
            line-height: 14px;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body {
            clear: both;
            padding-top: 10px;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list {
            clear: both;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item {
            clear: both;
            height: 40px;
            padding-bottom: 20px;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item .graph-bar-tit {
            width: 140px;
            height: 20px;
            font-size: 14px;
            line-height: 20px;
            float: left;
            font-weight: bold;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item .graph-bar-box {
            width: 75px;
            height: 15px;
            margin-top: 3px;
            background-color: #e6e6e6;
            border-left: 1px solid #ffffff;
            float: left;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item.col-s1 .graph-bar-box.on {
            background-color: #9FAFFF;
        }

        .col-s1 .graph-bar-box .graph-per-bar.m-25 {
            background-color:  #9FAFFF;
            height: 100%;
            width: 25%;
        }

        .col-s1 .graph-bar-box .graph-per-bar.m-50 {
                background-color:  #9FAFFF;
                height: 100%;
                width: 50%;
            }

        .col-s1 .graph-bar-box .graph-per-bar.m-75 {
                background-color:  #9FAFFF;
                height: 100%;
                width: 75%;
        }

        .col-s1 .graph-bar-box .graph-per-bar.m-100 {
                background-color:  #9FAFFF;
                height: 100%;
                width: 100%;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item.col-s2 .graph-bar-box.on {
            background-color: #92C8FF;
        }

        .col-s2 .graph-bar-box .graph-per-bar.m-25 {
            background-color:  #92C8FF;
            height: 100%;
            width: 25%;
        }

        .col-s2 .graph-bar-box .graph-per-bar.m-50 {
                background-color:  #92C8FF;
                height: 100%;
                width: 50%;
            }

        .col-s2 .graph-bar-box .graph-per-bar.m-75 {
                background-color:  #92C8FF;
                height: 100%;
                width: 75%;
        }

        .col-s2 .graph-bar-box .graph-per-bar.m-100 {
                background-color:  #92C8FF;
                height: 100%;
                width: 100%;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item.col-s3 .graph-bar-box.on {
            background-color: #31B3ED;
        }

        .col-s3 .graph-bar-box .graph-per-bar.m-25 {
            background-color:  #31B3ED;
            height: 100%;
            width: 25%;
        }

        .col-s3 .graph-bar-box .graph-per-bar.m-50 {
                background-color:  #31B3ED;
                height: 100%;
                width: 50%;
            }

        .col-s3 .graph-bar-box .graph-per-bar.m-75 {
                background-color:  #31B3ED;
                height: 100%;
                width: 75%;
        }

        .col-s3 .graph-bar-box .graph-per-bar.m-100 {
                background-color:  #31B3ED;
                height: 100%;
                width: 100%;
        }

        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item.col-s4 .graph-bar-box.on {
            background-color: #53CAFF;
        }

        .col-s4 .graph-bar-box .graph-per-bar.m-25 {
            background-color:  #53CAFF;
            height: 100%;
            width: 25%;
        }

        .col-s4 .graph-bar-box .graph-per-bar.m-50 {
                background-color:  #53CAFF;
                height: 100%;
                width: 50%;
            }

        .col-s4 .graph-bar-box .graph-per-bar.m-75 {
                background-color:  #53CAFF;
                height: 100%;
                width: 75%;
        }

        .col-s4 .graph-bar-box .graph-per-bar.m-100 {
                background-color:  #53CAFF;
                height: 100%;
                width: 100%;
        }


        .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item.col-s5 .graph-bar-box.on {
            background-color: #9AE0FF;
        }

        .col-s5 .graph-bar-box .graph-per-bar.m-25 {
                background-color:  #9AE0FF;
                height: 100%;
                width: 25%;
        }

        .col-s5 .graph-bar-box .graph-per-bar.m-50 {
                background-color:  #9AE0FF;
                height: 100%;
                width: 50%;
        }

        .col-s5 .graph-bar-box .graph-per-bar.m-75 {
                background-color:  #9AE0FF;
                height: 100%;
                width: 75%;
        }

        .col-s5 .graph-bar-box .graph-per-bar.m-100 {
                background-color:  #9AE0FF;
                height: 100%;
                width: 100%;
        }


        .pop-ev-write-wrap .chart-block {
        width: calc(100% - 560px);
        }
        button {
        background: #53CAFF 0% 0% no-repeat padding-box;
        border-radius: 3px;
        opacity: 1;
        font-size: 14px;
        letter-spacing: 0px;
        color: #FFFFFF;
        opacity: 1;
        padding: 5px 10px;
        border: none;
    }
        @media screen and (max-width: 955px) {
            .pop-ev-write-wrap .graph-block {
                width: 100%;
                padding-right: 0;
            }
            .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head {
                display: block;
            }
            .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head .graph-bar-head-tit-fir {
                width: 140px;
                display: block;
                float: left;
            }
            .pop-ev-write-wrap .graph-bar-wrap .graph-bar-head .graph-bar-head-tit {
                width: calc((100% - 140px) / 5);
                display: block;
                float: left;
            }
            .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item .graph-bar-tit {
                width: 140px;
                font-size: 12px;
            }
            .pop-ev-write-wrap .graph-bar-wrap .graph-bar-body .graph-bar-body-list .graph-bar-body-item .graph-bar-box {
                width: calc((100% - 140px) / 5);
            }
            .pop-ev-write-wrap .chart-block {
                width: 100%;
            }
        }
</style>
